import { render, staticRenderFns } from "./ItemFormTable.vue?vue&type=template&id=23c8430f&"
import script from "./ItemFormTable.vue?vue&type=script&lang=js&"
export * from "./ItemFormTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemFormTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports